import { BaseApiService } from "../base/base-api.service";
import { v4 as uuidv4 } from "uuid";
import {
  LegalEntityProjectDocumentSTO,
  LegalEntityProjectDTO,
  LegalEntityProjectRef,
  LegalEntityProjectSTO,
} from "../../models/legal-entity-projects";
import { ListSortDirection, Sort } from "../../models/api/sort";
import { DocumentRef } from "../../models/documents";
import { toastifyResponse } from "../../utils/toastify-response/toastify-response";

export class LegalEntityProjectsApiService extends BaseApiService<
  LegalEntityProjectDTO,
  LegalEntityProjectSTO | LegalEntityProjectDocumentSTO
> {
  constructor() {
    super({
      servicePath: "/LegalEntityProjects",
      loadItemsPath: "/GetLegalEntityProjects",
      saveItemsPath: "/SaveLegalEntityProjects",
    });
    this.defaultSort = [
      {
        name: "legalEntity.name",
        direction: ListSortDirection.Ascending,
      } as Sort,
      {
        name: "client.name",
        direction: ListSortDirection.Ascending,
      } as Sort,
      {
        name: "name",
        direction: ListSortDirection.Ascending,
      } as Sort,
    ];
  }
}

export const saveProjectDocument = async (project: LegalEntityProjectRef, document: DocumentRef) => {
  const service = new LegalEntityProjectsApiService();
  service.useSaveItemsPath("/SaveLegalEntityProjectsDocuments");
  const response = await service.saveItems([
    {
      id: uuidv4(),
      isDeleted: false,
      companyAccount: project.companyAccount,
      project,
      document,
    },
  ]);

  toastifyResponse(response, "failed");

  return response;
};
